(function () {
	const OPEN_DELAY = 300;
	const CLOSE_GRACE = 220;

	const bindMegaMenus = () => {
		document.querySelectorAll(".list-menu--megamenu").forEach((link) => {
			if (link.dataset.sep26MegaBound === "1") return;
			link.dataset.sep26MegaBound = "1";

			let openTimer = 0;
			let closeTimer = 0;

			link.addEventListener("mouseenter", () => {
				window.clearTimeout(closeTimer);
				window.clearTimeout(openTimer);
				openTimer = window.setTimeout(() => {
					link.classList.add("list-menu--megamenu-visible");
				}, OPEN_DELAY);
			});

			link.addEventListener("mouseleave", () => {
				window.clearTimeout(openTimer);
				window.clearTimeout(closeTimer);
				closeTimer = window.setTimeout(() => {
					link.classList.remove("list-menu--megamenu-visible");
				}, CLOSE_GRACE);
			});
		});
	};

	document.addEventListener("shopify:section:load", bindMegaMenus);
	bindMegaMenus();
})();
